import React from 'react';
import { Edit2 } from 'react-feather';

import { OrderInfoSectionProps } from '@/Order/types/orderTypes';

const OrderInfoSection: React.FC<OrderInfoSectionProps> = ({
  receiverInfo,
  user,
  onEditShipping,
}) => {
  const formatAddress = () => {
    const parts = [];
    if (receiverInfo.postalCode) {
      parts.push(receiverInfo.postalCode);
    }
    if (receiverInfo.addressDetail) {
      parts.push(receiverInfo.addressDetail);
    }
    return parts.join(' ');
  };

  return (
    <>
      <div className="flex flex-col rounded border border-gray-200 bg-white shadow-sm">
        <div className="p-5">
          <h3 className="text-base font-medium text-[#1D1D1D]">
            Contact Information
          </h3>
          <div className="mt-4 space-y-2 text-sm">
            <p className="text-[#8F689A]">{receiverInfo.companyName}</p>
            <p className="text-[#8F689A]">{receiverInfo.receiverName}</p>
            <p className="text-[#8F689A]">{receiverInfo.companyEmail}</p>
            <p className="text-[#8F689A]">{user.email}</p>
            <p className="text-[#8F689A]">{receiverInfo.phoneNumber}</p>
          </div>
        </div>
      </div>

      <div className="flex flex-col rounded border border-gray-200 bg-white shadow-sm">
        <div className="p-5">
          <div className="flex items-center justify-between">
            <h3 className="text-base font-medium text-[#1D1D1D]">
              Shipping Information
            </h3>
            <button
              type="button"
              className="cursor-pointer bg-transparent p-1"
              onClick={onEditShipping}
            >
              <Edit2 size={16} className="text-[#888888]" />
            </button>
          </div>
          <div className="mt-4 space-y-3 text-sm">
            <p className="text-[#1D1D1D]">{formatAddress()}</p>
            <div className="text-[#888888]">{receiverInfo.companyEmail}</div>
            <div className="text-[#1D1D1D]">{receiverInfo.receiverName}</div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OrderInfoSection;
